import { render, staticRenderFns } from "./HavaleCreate.vue?vue&type=template&id=12c64a90&scoped=true&"
import script from "./HavaleCreate.vue?vue&type=script&lang=js&"
export * from "./HavaleCreate.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/Havale/HavaleStyle.css?vue&type=style&index=0&id=12c64a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c64a90",
  null
  
)

export default component.exports